module.exports = __webpack_public_path__ + "f4cc3801350243025d9e739db5b069bc.png";